import { Injectable } from '@angular/core';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

type CategoryNames = 'Job'|'Reflection'|'Experience'|'AbTest';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    constructor(private googleAnalyticsService: GoogleAnalyticsService) { }

    sendEvent(categoryName: CategoryNames, label: string, value?: string) {
        console.log('GA Event', label, categoryName, value);
        if (!this.googleAnalyticsService) return;

        this.googleAnalyticsService.event(label, categoryName, value);
    }
}
